export default __webpack_public_path__ + "static/media/CIHE_Composición 1.02f9908c.jpg";